<div
    class="cw-global-header-icon"
    (click)="showAccountinfo()"
    matTooltip="{{ 'GLOBAL.ACCOUNTINFO.HEADER' | translate }}">
    <span class="cw-global-header-usericon">
        <img [src]="userIcon" width="40" height="40" />
    </span>
</div>
